if (!customElements.get('media-player')) {
  customElements.define(
    'media-player',
    class MediaPlayer extends HTMLElement {
      constructor() {
        super()
        this.isPlaying = false
        this.muteButton =  this.querySelector('.media-player__mute')
        this.playButton = this.querySelectorAll('.media-player__button')
        this.fullscreenButton = this.querySelector('.media-player__fullscreen')
        this.poster = this.querySelector('.media-player__poster')
        this.progressBar = this.querySelector('.media-player__progress-bar')
        this.progressFill = this.querySelector('.media-player__progress-fill')
        this.currentTime = this.querySelector('[data-current-time]')
        this.totalTime = this.querySelector('[data-total-time]')
      }

      connectedCallback() {
        this.media = this.querySelector('video, audio')
        this.isMuted = this.media.muted
        this.eventListeners()
      }
      eventListeners() {
        this.addEventListener('click', (e) => {
          const target = e.target
          if (target.classList.contains('media-player__fullscreen')) {
            this.fullscreen()
          }
          if (target.classList.contains('media-player__button') || target.classList.contains('media-player__play')) {
            this.togglePlay(target)
          }
          if (target.classList.contains('media-player__poster')) {
            target.classList.add('hidden')
            this.setAttribute('loaded', '')
            this.play()
            this.setAttribute('playing','')
          }
          if(target.classList.contains('media-player__mute')) { 
            this.muted()
          }
          if (
            target === this.poster &&
            !this.poster.classList.contains('hidden')
          ) {
            this.poster.classList.add('hidden')
            this.setAttribute('loaded', '')
            this.play()
          }
          if (target.classList.contains('media-player__progress-bar')) {
            this.seek(e)
          }
        })
        this.media.addEventListener('timeupdate', () => {
          this.updateProgressBar()
        })
        this.progressBar.addEventListener('mousedown', (e) => {
          this.dragSeek(e)
        })
        document.addEventListener('keydown', (e) => {
          const key = e.key
          if (e.target === this.progressBar) {
            const skipSec = 3
            if (key === 'ArrowLeft') {
              this.skip(-skipSec)
            } else if (key === 'ArrowRight') {
              this.skip(skipSec)
            }
          }
        })
        this.progressBar.addEventListener('mouseup', (e) => {
          this.seek(e)
        })
        this.media.addEventListener('loadedmetadata', () => {
          this.updateTotalTime()
        })
        if(this.fullscreenButton !== null) {
          this.media.addEventListener('fullscreenchange', () => {
            if(document.fullscreenElement) { 
              this.media.addEventListener('play', () => { 
                this.playButton.forEach(btn => { 
                  btn.setAttribute('data-state','pause')
                  this.setAttribute('playing','')
                  this.removeAttribute('paused')
                })
              })
              this.media.addEventListener('pause', () => {
                this.playButton.forEach(btn => { 
                  btn.setAttribute('data-state', 'play')
                  this.setAttribute('paused','')
                  this.removeAttribute('playing')
                })
              })
              this.media.addEventListener('volumechange', () => { 
                const mute = this.muteButton.querySelector('[data-mute="false"]')
                const unmute = this.muteButton.querySelector('[data-mute="true"]')
                if(this.media.muted) {
                  mute.classList.remove('hidden')
                  unmute.classList.add('hidden')
                } else {
                  mute.classList.add('hidden')
                  unmute.classList.remove('hidden')
                }
              })
            }         
          })
        }
        this.media.addEventListener('ended', () => {
          this.isPlaying = false
          this.removeAttribute('playing')
          this.setAttribute('paused','')
          this.playButton.forEach((button) => {
            button.setAttribute('data-state', 'play')
            this.isMuted = false
            const mute = this.muteButton.querySelector('[data-mute="true"]')
            const unmute = this.muteButton.querySelector('[data-mute="false"]')
            mute.classList.remove('hidden')
            unmute.classList.add('hidden')
          })
        })
      }

      togglePlay(target) {  
        const playButtons = this.querySelectorAll('.media-player__button')
        if (target.dataset.state === 'play') {
          window.pauseAllMedia()
          playButtons.forEach((btn) => {
            btn.setAttribute('data-state', 'pause')
            this.setAttribute('playing','')
            this.removeAttribute('paused')
          })
          this.media.play()
          this.media.muted = false
          this.isPlaying = true
          if(this.isMuted === true) {
            this.media.muted = true
          } 
        } else {
          playButtons.forEach((btn) => {
            btn.setAttribute('data-state', 'play')
            this.setAttribute('paused','')
            this.removeAttribute('playing')
          })
          this.media.pause()
          this.isPlaying = false
        }
      }
      fullscreen() {
        if (!document.fullscreenElement) {
          const isPaused = this.media.paused
          const isMuted = this.media.muted
          window.pauseAllMedia()
          this.media.requestFullscreen().then(() => {
            if (isPaused) {
              this.pause()
            } else {
              this.play()
            }
          })
        } else {
          document.exitFullscreen()
        }
      }

      play() {
        window.pauseAllMedia()
        this.classList.remove('paused')
        this.isPlaying = true
        this.media.play()
        this.playButton.forEach((button) => {
          button.setAttribute('data-state', 'pause')
        })
      }
      muted() { 
        const mute = this.muteButton.querySelector('[data-mute="true"]')
        const unmute = this.muteButton.querySelector('[data-mute="false"]')
        if(this.media.muted === false) {
          this.media.muted = true
          this.isMuted = true
          unmute.classList.remove('hidden')
          mute.classList.add('hidden')
        } else { 
          this.media.muted = false
          this.isMuted = false
          mute.classList.remove('hidden')
          unmute.classList.add('hidden')
        }
      }
      pause() {
        this.isPlaying = false
        this.media.pause()
        this.media.muted = true
        this.classList.add('paused')
        this.playButton.forEach((button) => {
          button.setAttribute('data-state', 'play')
        })
      }

      updateProgressBar() {
        const progressPercent =
          (this.media.currentTime / this.media.duration) * 100
        this.progressFill.style.width = `${progressPercent}%`
        this.updateCurrentTime()
      }

      updateCurrentTime() {
        const currentMinutes = Math.floor(this.media.currentTime / 60)
        const currentSeconds = Math.floor(this.media.currentTime % 60)
          .toString()
          .padStart(2, '0')
        this.currentTime.textContent = `${currentMinutes}:${currentSeconds}`
      }

      updateTotalTime() {
        let totalMinutes = 0
        let totalSeconds = 0

        if (isFinite(this.media.duration)) {
          totalMinutes = Math.floor(this.media.duration / 60)
          totalSeconds = Math.floor(this.media.duration % 60)
            .toString()
            .padStart(2, '0')
        }

        this.totalTime.textContent = 'Hello'
        this.totalTime.textContent = `${totalMinutes}:${totalSeconds}`
      }

      dragSeek(e) {
        this.media.pause()
        this.seek(e)
      }

      seek(e) {
        const seekPercent = e.offsetX / this.progressBar.clientWidth
        const newTime = seekPercent * this.media.duration
        this.media.currentTime = newTime
        if (this.isPlaying) {
          this.media.play()
        } else {
          this.media.pause()
        }
      }
      skip(sec) {
        this.media.currentTime += sec
      }
    }
  )
}
